function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
            const video = entry.target
            video.src = video.dataset.src
            video.load()
            observer.unobserve(video);
        }
      });
    }, { threshold:0,rootMargin: '500px', });
  
    elements.forEach(el => observer.observe(el));
}
onViewLoad('.box4_video')

var wFlag=window.innerWidth>750

$(()=>{
    
    //box2
    $('.box2_btn').click(function(){
        $('.box2_mask').addClass('block')
        $('.box2_card').addClass('scale1')
    })
    $('.box2_close').click(function(){
        $('.box2_mask').removeClass('block')
        $('.box2_card').removeClass('scale1')
    })

    //box7
    showUp('.box7_text')
    $('.box7_btn .box7_popup:last-child').click(function(){
        $('.box7_mask').fadeIn()
    })
    $('.box7_close').click(function(){
        $('.box7_mask').fadeOut()
    })
    $('.box7_tips').click(function(){
        $('.box7_mask2').fadeIn()
    })
    $('.box7_close2').click(function(){
        $('.box7_mask2').fadeOut()
    })

    //box1
    showUp('.box1_text')

    //box6
    showUp('.box6_title')

    //box3
    showUp('.box3_title')
    showUp('.box3_text')

    //box4
    var $video = $('.box4_video'); 
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top',
            end:'+=200%',
            scrub:true,
            onUpdate: function (self) {
                $video[0].currentTime = self.progress * 9
            }
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=200% top',
            end:'+=30%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
            // translate(20%, 15%) scale(0.5)
                .to('.box4_video',{x:'16%',y:'20%',scale:0.7,duration:0.7})
                .from('.box4_item',{opacity:0,duration:0.3})
                .from('.box4_subText',{opacity:0,y:'2rem'},'<')
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top',
            end:'+=240%',
            pin:true,
        })
    }else{
        showUp('.box4_text')
        $video.attr('autoplay','true')
        //$video.attr('loop','true')
    }

    //box5
    var box5Swiper = new Swiper('.box5Swiper', {
        on:{
            slideChange: function(){
                var index = this.activeIndex
                $('.box5_btn div').eq(index).addClass('box5Active').siblings().removeClass('box5Active')
            },
        }
    })
    $('.box5_btn div').click(function(){
        var index = $(this).index()
        $(this).addClass('box5Active').siblings().removeClass('box5Active')
        box5Swiper.slideTo(index, 300, false);
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top',
            end:'+=20%',
            //scrub:1,
            animation:gsap.timeline()
                .to('.box5_mask',{x:'-13.5%',y:'2%',scale:0.5,opacity:0})
        })

        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top',
            end:'+=30%',
            pin:true,
        })
    }else{
        showUp('.box5_title')
    }

    //box8
    showUp('.box8_title')
    
})